import { SaleFormValues, SaleRegistrationDTO } from "../../../types/sale/SaleTypes";

export const mapSaleFormToDTO = (form: SaleFormValues): SaleRegistrationDTO => {
  return {
    saleDate: form.saleDate,
    documentTypeId: form.documentType?.id!,
    customerId: form.customer?.id ?? null,
    branchId: form.branch?.id!,
    comments: form.comments || '',
    paymentConditionId: form.paymentCondition?.id ?? null,
    paymentMethodId: null,
    creditDays: null,
    creditDueDate: null,
    correlativeId: form.correlativeId ?? null,
  };
};
